export enum EBrokerType {
  BROKER = 'BROKER',
  BROKER_CLIENT = 'BROKER_CLIENT',
  NO = 'NO',
}
